import React, { Component, Fragment } from 'react'
import moment from 'moment/moment'
import { Button } from 'antd'
import Status from '../../../../elements/Status'
import { strVal } from '../../../../modules/Utils'
import TableSpin from '../../../../elements/TableSpin'
import ReactTable from 'react-table-v6'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import InfoText from '../../../../elements/InfoText'
import { compose, withState } from 'recompose'
import FilterButton from '../../../../elements/Buttons/FilterButton'
import TableHeader from '../../../../elements/Table/Header'

class LeavesList extends Component {
  async componentDidMount() {
    await this.props.fetch()
  }

  columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ original, value }) => {
        return <a onClick={(e) => this.props.onShow(e, original)}>{value}</a>
      },
    },
    {
      Header: 'Name',
      accessor: 'owner.fn',
    },

    {
      Header: 'Type',
      accessor: 'leave.type',
    },
    {
      Header: 'Days',
      accessor: 'total',
      // aggregate: values => _.sum(values),
    },

    {
      Header: 'Start',
      accessor: 'date.start',
      Cell: ({ value }) => value && moment(value).format('YYYY-MM-DD'),
      PivotValue: () => null,
    },
    {
      Header: 'End',
      accessor: 'date.end',
      Cell: ({ value }) => value && moment(value).format('YYYY-MM-DD'),
      PivotValue: () => null,
    },
    {
      Header: 'Submitted',
      accessor: 'date.submitted',
      Cell: ({ value }) => value && moment(value).format('YYYY-MM-DD'),
      PivotValue: () => null,
    },
    {
      Header: 'Reason',
      accessor: 'reason',
      PivotValue: () => null,
    },
    {
      Header: 'Status',
      accessor: 'status',
      PivotValue: () => null,
      Cell: ({ original, value }) => <Status tooltip={false} value={value} />,
    },
  ]

  render() {
    const { list, fetching, option, fetch, onShow, filterable, setFilterable } = this.props
    if (option === 'personal') this.columns = this.columns.filter((c) => c.accessor !== 'owner.fn')
    return (
      <Fragment>
        <TableHeader>
          <Button type={'primary'} icon={'plus'} size={'small'} style={{ float: 'left' }} onClick={onShow}>
            Apply for Leave
          </Button>
          <div style={{ float: 'right' }}>
            <RefreshButton onClick={fetch} />
            <FilterButton style={{ marginRight: 10 }} onClick={() => setFilterable((f) => !f)} />
          </div>
        </TableHeader>
        <ReactTable
          columns={this.columns}
          data={list}
          filterable={filterable}
          multiSort={true}
          loading={fetching}
          defaultPageSize={10}
          style={{ minHeight: '512px' }}
          LoadingComponent={TableSpin}
          defaultFilterMethod={(filter, row) =>
            strVal(row, filter.id).toUpperCase().includes(strVal(filter, 'value').toUpperCase())
          }
          // pivotBy={option === 'personal' ? ['leave.code'] : []}
        />
        <InfoText text={'Click on the ID to view and update Leave'} />
        <InfoText text={'Tip: Hold shift when sorting to multi-sort!'} />
      </Fragment>
    )
  }
}

LeavesList.propTypes = {}
LeavesList.defaultProps = {}

export default compose(withState('filterable', 'setFilterable', false))(LeavesList)
